import axios from "axios";
import * as endpoints from "./const";

class BookmarksApi {
  static fetchDriverBookmarks(fetchParams) {
    const endpointUrl = `${endpoints.BOOKMARKS_DRIVER}`;
    return axios.get(endpointUrl, {
      params: fetchParams
    });
  }

  static fetchVehicleBookmarks(fetchParams) {
    const endpointUrl = `${endpoints.BOOKMARKS_VEHICLE}`;
    return axios.get(endpointUrl, {
      params: fetchParams
    });
  }

  static fetchBookmarks(fetchParams) {
    return axios
      .all([
        BookmarksApi.fetchDriverBookmarks(fetchParams),
        BookmarksApi.fetchVehicleBookmarks(fetchParams)
      ])
      .then(
        axios.spread(function(driver, vehicle) {
          // Both requests are now complete
          let driverResp, vehicleResp;
          if(driver && driver.data && driver.data.data) driverResp = driver.data.data;
          if(vehicle && vehicle.data && vehicle.data.data) vehicleResp = vehicle.data.data;
          return { driver: driverResp, vehicle: vehicleResp };
        })
      );
  }
}

export default BookmarksApi;



// WEBPACK FOOTER //
// ./src/api/BookmarksApi.js